import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'EVENT_FORM';

const eventFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EventService.find(id);
      }

      dispatch({
        type: eventFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventFormActions.INIT_ERROR,
      });

      getHistory().push('/event');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: eventFormActions.CREATE_STARTED,
      });

      await EventService.create(values);

      dispatch({
        type: eventFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.event.create.success'),
      );

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: eventFormActions.UPDATE_STARTED,
      });

      await EventService.update(id, values);

      dispatch({
        type: eventFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.event.update.success'),
      );

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default eventFormActions;
